/**
 * Encodes content (line breaks, etc. to be decoded in Marketo. This is a
 * workaround for Marketo refusing to accept HTML and stripping out certain
 * characters.
 *
 * @param text The text to encode.
 * @returns String The encoded text.
 */export function encodeContent(text){for(const[replacement,pattern]of encodingMap){text=text.replace(pattern,replacement)}return text}export const encodingMap=[["[br/]",/\n/g],["[br/]",/<br\/>/g],["[strong]$1[/strong]",/<strong>([^<]+)<\/strong>/g]];